import { render, staticRenderFns } from "./editService.vue?vue&type=template&id=180ea62c&scoped=true"
import script from "./editService.vue?vue&type=script&lang=js"
export * from "./editService.vue?vue&type=script&lang=js"
import style0 from "./editService.vue?vue&type=style&index=0&id=180ea62c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180ea62c",
  null
  
)

export default component.exports